import React from "react";
import AnimatedContainer from "./AnimatedContainer";
import Card from "./Card";

function Importancia (){
    const imageUrl='https://raw.githubusercontent.com/LTuhay/rosa-recicla/master/public/assets/important.jpg';
    const text='Desde una perspectiva macro, reciclar se ha convertido en una necesidad humana que contribuye a reducir la contaminación tanto de las aguas como de los suelos al convertir la industria en un proceso sustentable que permita una vida saludable en nuestro planeta.'
    const additionalText= 'Si bien hoy por hoy es una actividad minoritaria dado que fabricar algo nuevo es más rentable que reciclar algo viejo, hablando en términos ecológicos, a lo largo del tiempo, se va convirtiendo en una necesidad. Asimismo, actualmente hay empresas que compran productos desechados y los usan como materia prima para su proceso de fabricación, lo que se puede convertir en una actividad moderadamente lucrativa';

    return (
        <div>
            <AnimatedContainer animationDuration="2s">
                <Card image={imageUrl} title='La importancia de reciclar' text={text} additionalText={additionalText} imagePosition='left' />
            </AnimatedContainer>
        </div>
    )
}

export default Importancia;